import { render, staticRenderFns } from "./quotation_version.vue?vue&type=template&id=6eb18b20&scoped=true&"
import script from "./quotation_version.vue?vue&type=script&lang=js&"
export * from "./quotation_version.vue?vue&type=script&lang=js&"
import style0 from "./quotation_version.vue?vue&type=style&index=0&id=6eb18b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb18b20",
  null
  
)

export default component.exports